import React from 'react';
import MembershipInputAccompanyTemplate from '../../components_membership_hotel/template/hotel/membershipInputAccompanyTemplate';
import { getReserveList, getSenyuNenList } from '../../const';
import image_base from '../../resources/image/HakoneGardenTerrace.jpg';
import common from "../../resources/js/common/common";

class MembershipInputAccompany extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            // 申込条件モーダル
            membershipPopup: false,
            popupDataList: [],
            popupMessage: "",
            popupMode: "",
            popupTitle: "",
            // 画面表示フラグ
            displayType: "input",
            // 戻るボタンの遷移先
            path: "",
            // 予約キャンセルモーダル
            membershipReservationCancelPopup: false,
            // 占有日モーダル
            senyuubiPopup: false,
            shokaKenriNenList: [],
            // 「ホームFLとは」モーダル
            descHomeFlPopup: false,
            // ローディング画面表示フラグ
            loadingFlg: false
        };
    };

    render() {
        const style = {
            base: {
                backgroundImage: `url(${image_base})`,
                backgroundAttachment: "fixed",
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
            },
        }

        // 予約確認モーダル
        const onClickOpenReservationPopupWindow = (pointKaiinId) => {
            this.setState({ membershipReservationConfPopup: true, loadingFlg: true });
            common.doPost(getReserveList, { pointKaiinId: pointKaiinId }, afterGetReserveList);
        }
        // 予約情報取得後処理
        const afterGetReserveList = (res) => {
            let data = res.data;
            if (data.resultCode == 0) {
                this.setState({ reservationConfList: res.data, });
            }
            this.setState({ loadingFlg: false });
        }

        // モーダルClose
        const onClickClosePopupWindow = () => { this.setState({ membershipPopup: false }); };
        // 予約確認モーダルを閉じる
        const onClickCloseReservationConfPopupWindow = () => { this.setState({ membershipReservationConfPopup: false }); };

        // popupMode変更
        const setPopupMode = (mode) => this.setState({ popupMode: mode })

        // popUpMessage変更
        const setPopupMessage = (message) => this.setState({ popupMessage: message })

        // 画面表示変更
        const setDisplayType = (type) => this.setState({ displayType: type })

        // 戻るボタンの遷移先
        const setAccompanyPath = (path) => this.setState({ path: path })

        // キャンセルモーダル
        const onClickOpenCancelPopupWindow = () => {
            this.setState({ membershipReservationCancelPopup: true });
        }
        // キャンセルモーダルClose
        const onClickCloseCancelPopupWindow = () => { this.setState({ membershipReservationCancelPopup: false }); };

        // 占有日モーダル
        const onClickOpenSenyuubiWindow = (keiyakuNo) => {
            common.doPost(getSenyuNenList, { keiyakuNo: keiyakuNo }, afterGetSenyuNenList);
        }

        // 「ホームFlとは」モーダル
        const onClickOpenDescriptionHomeFlWindow = () => { this.setState({ descHomeFlPopup: true }); };

        // 占有日一覧取得後処理
        const afterGetSenyuNenList = (res) => {
            const data = res.data;
            if (data.resultCode == 0) {
                this.setState({
                    senyuubiPopup: true,
                    shokaKenriNenList: data.shokaKenriNenList
                });
            } else {
                this.setState({ 
                    senyuubiPopup: true,
                    shokaKenriNenList: []
                });
            }
        }

        // 占有日モーダルを閉じる
        const onClickCloseSenyuubiPopupWindow = () => { this.setState({ senyuubiPopup: false }); };

        // 「ホームFlとは」モーダルを閉じる
        const onClickCloseDescriptionHomeFlWindow = () => { this.setState({ descHomeFlPopup: false }); };

        return (
            <div style={style.base}>
                <MembershipInputAccompanyTemplate
                    state={this.state}
                    onClickOpenReservationPopupWindow={onClickOpenReservationPopupWindow}
                    setPopupMode={setPopupMode}
                    setPopupMessage={setPopupMessage}
                    onClickClosePopupWindow={onClickClosePopupWindow}
                    setDisplayType={setDisplayType}
                    setAccompanyPath={setAccompanyPath}
                    onClickCloseReservationConfPopupWindow={onClickCloseReservationConfPopupWindow}
                    onClickOpenCancelPopupWindow={onClickOpenCancelPopupWindow}
                    onClickCloseCancelPopupWindow={onClickCloseCancelPopupWindow}
                    onClickOpenSenyuubiWindow={onClickOpenSenyuubiWindow}
                    onClickCloseSenyuubiPopupWindow={onClickCloseSenyuubiPopupWindow}
                    onClickOpenDescriptionHomeFlWindow={onClickOpenDescriptionHomeFlWindow}
                    onClickCloseDescriptionHomeFlWindow={onClickCloseDescriptionHomeFlWindow}
                />
            </div>
        )
    }
}
export default MembershipInputAccompany;
